module.exports = __webpack_public_path__ + "static/media/buy_start_service_help_3.f4fe5749.jpg";